import React,{useState , useEffect, SetStateAction, useRef} from 'react'
import Pitch from '../Pitch'
import { teamSegmentGameModelGroup } from '../ClubDetail/Performance/GameModel'
import LabelText from '../../ui/LabelText'
import { IClubComparisonData } from '../../types/ClubComparison'
import IApiResponse from '../../types/IApiResponse'
import { postData } from '../../services/api'
import apiUrls from '../../config/apiUrls'
import handleApiResponse from '../../utils/handleApiResponse'
import { IGameModel } from '../../types/IClubDetail'
import Plus from "../../assets/icons/Plus.png";
import True from '../../assets/icons/Tick.png';
import LoadingSpinner from '../../ui/LoadingSpinner'
import PWNotification from '../PWNotification'
import { set } from 'lodash'
import LabelNumber from '../../styled-components/LabelNumber'

interface IClubCompareGameModel {
  clubComparisonData: IClubComparisonData[];
}

const ClubSortlistGameModel : React.FC<IClubCompareGameModel> = ({clubComparisonData}) => {

  const [gameModelData, setGameModelData] = useState<IGameModel[]>([])
  const [gameModelCompareData, setGameModelCompareData] = useState<IGameModel[]>([]);
  const [isGameModelLoading , setIsGameModelLoading] = useState<boolean>(false);
  const [displayNotification, setDisplayNotification] = useState<boolean>(false);
  const [selectedTeamIds, setSelectedTeamIds] = useState<number[]>([]);
  const [selectedSeasonIds, setSelectedSeasonIds] = useState<number[]>([]);
  const [selectedteamLogoURL, setTeamLogoURL] = useState<string[]>([]);
  const [selectedteamLabel, setTeamLabel] = useState<string[]>([]);
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>([
        "crosses",
        "passes_to_final_third",
        "shots",
        "defensive_duels"
  ]);

  const handleGameModelAttributesSelection = (key: string) => {
        setSelectedAttributes(prev =>
          prev.includes(key)
            ? prev.filter(item => item !== key)
            : [...prev, key]
        );
  };

  const fetchGamneModelData = async (teamId: number ,seasonId : number, setData: (data: IGameModel[]) => void)  => {
        setIsGameModelLoading(true);
        try {
          const response: IApiResponse<IGameModel[]> = await postData(`${apiUrls["GetGameModel"]}`, {
            seasonId: seasonId,
            teamId: teamId,
            typeFilter: selectedAttributes
          });
    
          handleApiResponse(    
            response,
            (gameModelData) => {
              setIsGameModelLoading(false);
              setData(gameModelData);
            },
            (error) => {
              setIsGameModelLoading(false);
              console.error("Error fetching Game Model Data:", error);
            }
          );
        } catch (error) {
          setIsGameModelLoading(false);
          console.error("Unexpected error while Game Model Data:", error);
        }
  };

    useEffect(() => {
      if (selectedTeamIds.length === 0 || selectedSeasonIds.length === 0) return;
      fetchGamneModelData(selectedTeamIds[0],selectedSeasonIds[0], setGameModelData);
  }, [selectedTeamIds[0],selectedSeasonIds[0], selectedAttributes]);


    useEffect(()=>{
      if (selectedTeamIds.length === 0 || selectedSeasonIds.length === 0) return;
      fetchGamneModelData(selectedTeamIds[1] , selectedSeasonIds[1], setGameModelCompareData);
    },[selectedTeamIds[1], selectedSeasonIds[1],selectedAttributes]);


   useEffect(() => {
      if (!clubComparisonData || clubComparisonData.length === 0 || selectedTeamIds.length === 0) return;

      const matchedSeasonIds = selectedTeamIds.map(teamId => {
        const matchedClub = clubComparisonData.find(club => club.teamId === teamId);
        return matchedClub?.competitionSeasonId ?? null;
      });

      // Only update if both seasonIds are found (not null)
      if (matchedSeasonIds.every(id => id !== null)) {
        setSelectedSeasonIds(matchedSeasonIds as number[]);
      }

    }, [clubComparisonData, selectedTeamIds]);

// useEffect(() => {
//   // if (!clubComparisonData || clubComparisonData.length < 2) return;

//   const defaultTeams = clubComparisonData.slice(0, 2);

//   defaultTeams.forEach((club) => {
//     const teamId = club?.teamId;
//     const seasonId = club?.competitionSeasonId;
//     const teamLogoURL = club?.teamLogoURL;
//     const teamLabel = club?.teamLabel;

//     // if (!teamId || !seasonId || !teamLogoURL || !teamLabel) return;

//     const teamIndex = selectedTeamIds.indexOf(teamId);

//     if (selectedTeamIds.length === 2 && teamIndex === -1) {
//       // Cannot add more
//       setDisplayNotification(true);
//     } else if (teamIndex !== -1) {
//       // Remove team
//       setSelectedTeamIds((prev) => prev.filter((id) => id !== teamId));
//       setSelectedSeasonIds((prev) => prev.filter((_, i) => selectedTeamIds[i] !== teamId));
//       setTeamLogoURL((prev) => prev.filter((_, i) => selectedTeamIds[i] !== teamId));
//       setTeamLabel((prev) => prev.filter((_, i) => selectedTeamIds[i] !== teamId));
//       setDisplayNotification(false);
//     } else {
//       // Add team
//       setSelectedTeamIds((prev) => [...prev, teamId]);
//       setSelectedSeasonIds((prev) => [...prev, seasonId]);
//       setTeamLogoURL((prev) => [...prev, teamLogoURL]);
//       setTeamLabel((prev) => [...prev, teamLabel]);
//     }
//   });
// }, []);


    const handleAddingTeamsToCompare = (
    event: React.MouseEvent,
    teamId?: number,
    teamLogoURL?: string,
    teamLabel?: string,
    seasonId?: number
    ) => {
          event.stopPropagation();
          // if (teamId == null || seasonId == null || !teamLogoURL || !teamLabel) {
          //   console.warn("Missing team info");
          //   return;
          // }
          const teamIndex = selectedTeamIds.indexOf(teamId!);

          if (selectedTeamIds.length === 2) {
            if (teamIndex !== -1) {
              // Remove team
              setSelectedTeamIds(selectedTeamIds.filter((id) => id !== teamId));
              setSelectedSeasonIds(selectedSeasonIds.filter((id, i) => selectedTeamIds[i] !== teamId));
              setTeamLogoURL(selectedteamLogoURL.filter((_, i) => selectedTeamIds[i] !== teamId));
              setTeamLabel(selectedteamLabel.filter((_, i) => selectedTeamIds[i] !== teamId));
              setDisplayNotification(false);
            } else {
              // Notify can't add more
              setDisplayNotification(true);
            }
          } else {
            if (teamIndex !== -1) {
              // Remove
              setSelectedTeamIds(selectedTeamIds.filter((id) => id !== teamId));
              setSelectedSeasonIds(selectedSeasonIds.filter((id, i) => selectedTeamIds[i] !== teamId));
              setTeamLogoURL(selectedteamLogoURL.filter((_, i) => selectedTeamIds[i] !== teamId));
              setTeamLabel(selectedteamLabel.filter((_, i) => selectedTeamIds[i] !== teamId));
            } else {
              // Add
              setSelectedTeamIds([...selectedTeamIds!, teamId!]);
              setSelectedSeasonIds([...selectedSeasonIds!, seasonId!]);
              setTeamLogoURL([...selectedteamLogoURL!, teamLogoURL!]);
              setTeamLabel([...selectedteamLabel!, teamLabel!]);
            }
          }
    };
  return (
    <>
    <div className='compare-gamemodel-main'>
        {/* <div className='club-sidebar-list'> */}
            <div className='plot-player-list'>
              {clubComparisonData?.map((club, index) => (
                <div className='plot-player-tab' style={{backgroundColor: selectedTeamIds.includes(club?.teamId) ? 'white' : 'rgba(242, 245, 238, 1.75)'}}>
                  <div>
                      <div className='player-tab-img-container'>
                        {/* <div className='plot-player-image'> */}
                          <img src={club?.teamLogoURL} width={32} height={32}/>
                        {/* </div> */}
                      </div>
                      <div className='player-tab-name'>
                        <p>{club?.teamLabel}</p>
                      </div>
                      </div>
                       <div className="tracker-plus-container" onClick={(event) => handleAddingTeamsToCompare (event, club?.teamId , club?.teamLogoURL , club?.teamLabel,club?.competitionSeasonId)} >
                            {selectedTeamIds.includes(club?.teamId) ? (<img src={True} alt="plus-icon" /> ) :(<img src={Plus} alt='correct-icon'/>)}
                        </div>
                  
                </div>
              ))}
              
            </div>
        {/* </div> */}
        
        <div className='compare-gamemodel-container'>
           <div style={{display:'flex',gap:'20px'}}>
              <div className='gamemodel-pitch-container'>
                <div style={{height:'40px',display:'flex',alignItems:'center',gap:'10px'}}>
                  <LabelText className='player-detail-given-name'>{selectedteamLabel[0]}</LabelText>
                  {selectedteamLogoURL[0] && (<img src={selectedteamLogoURL[0]!} width={24} height={24}/>)}
                </div>
                
                  <Pitch
                  currentView='GameModel'
                  gameModelData={gameModelData}/>
                  
              </div>
              <div className='gamemodel-pitch-container'>
                <div style={{height:'40px',display:'flex',alignItems:'center',gap:'10px'}}>
                  <LabelText className='player-detail-given-name'>{selectedteamLabel[1]}</LabelText>
                  {selectedteamLogoURL[1] && (<img src={selectedteamLogoURL[1]!} width={24} height={24}/>)}
                </div>
               
                  <Pitch
                  currentView='GameModel'
                  gameModelData={gameModelCompareData}/>
                  
              </div>
          </div>
          <div className='attributes-table-main'>
                  {teamSegmentGameModelGroup?.map((section, index) => (
                      <div className='attributes-group-container' key={index}>
                      <div className='group-title-container'>
                          <LabelText className='player-given-name'>{section.title}</LabelText>
                      </div>
                      <div className='group-attributes-container'>
                          {section.Segments.map((attr, idx) => (
                              <>
                                  <div className='attribute-table-selection-item' key={idx}  style={{backgroundColor : selectedAttributes.includes(attr.key)? 'white' :'transparent'}}>
                                      <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                      <input
                                          type="checkbox"
                                          id={attr.key}
                                          className="custom-checkbox"
                                          name="game_model_attribute"
                                          value={attr.key}
                                          checked={selectedAttributes.includes(attr.key)}
                                          onChange={() => handleGameModelAttributesSelection(attr.key)}
                                      />
                                      <div style={{height:'9px',width:'9px',borderRadius:'2px',background:attr.color}}></div>
                                      <LabelText style={{color:attr.color}}>{attr.label}</LabelText>
                                      </div>
                                      
                                  </div>
                                  {/* <Line/> */}
                              </>
                          ))}
                      </div>
                      </div>
                  ))}
          </div>
         
        </div>
    </div>
    {displayNotification && (
            <PWNotification
              message={"Max visible clubs visible on chart. To add other clubs, turn existing ones off first."}
              setIsNotification={() => setDisplayNotification(false)}
              isDisplayCloseIcon={true}
              className="tracker-selection-notification"
            />
          )}
          {isGameModelLoading && <LoadingSpinner />}
    </>
  )
}

export default ClubSortlistGameModel